import type { DTOProfileCard } from 'src/apis/dto/DTOProfileCard';

import { APIClientType } from '.';

/**
 * Azar Multi Profile 피쳐에서 도입된 '프로필 카드' 관련 API 를 담고 있는 서비스.
 *
 * 아직 이 서비스에서는 특정 타입의 프로필 카드를 단일 제공하는 API 만을 가지고 있다.
 *
 * 자기 자신의 프로필 정보를 바꾸는 API 는 {@link UserProfileService},
 * 친구 프로필 정보를 바꿀수 있는 API 는 {@link FriendService} 에 있는 기존 API 들을 재활용하고 있고,
 * Async 관련 피쳐의 경우에는 {@link AsyncApiService} 을 이용해 여러 프로필 리스트를 받아올 수도 있다.
 *
 *
 * @since 1480
 */
export interface ProfileCardApiServiceType {
  /**
   * 특정 {@code type}, 특정 {@code id}에 해당하는 단일 프로필 카드를 얻어온다.
   * 프로필 카드를 받아오는 각 상황에 따라 type 이 결정되고, 해당 type 에 따라 다른 곳에서 사용하고 있는 id 를 이용해 호출한다.
   * @see {@link ProfileCard}
   *
   * @param type 프로필 카드의 타입. 이는 {@link ProfileCard#getType()}과 같아야 한다.
   * @param id 프로필 카드의 타입별 ID.
   * @return 프로필 카드
   * @throws AuthenticationException 로그인 상태가 아닌 경우
   * @since 1480
   */
  getProfileCard: (type: string, id: string) => Promise<DTOProfileCard>;
}

export class ProfileCardApiService implements ProfileCardApiServiceType {
  private client: APIClientType;

  constructor(customClient: APIClientType) {
    this.client = customClient;
  }

  public getProfileCard = async (type: string, id: string) => {
    return this.client.call<DTOProfileCard, Parameters<typeof this.getProfileCard>>({
      method: 'getProfileCard',
      data: [type, id],
    });
  };
}
